export const REQUEST_LASTADJUSTMENTS = 'REQUEST_LASTADJUSTMENTS';
export const RECEIVE_LASTADJUSTMENTS = 'RECEIVE_LASTADJUSTMENTS';
export const REQUEST_ANNOTATEDTEXTS = 'REQUEST_ANNOTATEDTEXTS';
export const RECEIVE_ANNOTATEDTEXTS = 'RECEIVE_ANNOTATEDTEXTS';

import {get, apiRoutes} from './../../api/api';

function requestLastAdjustments() {
  return {
    type: REQUEST_LASTADJUSTMENTS
  };
}

function receiveLastAdjustments(data) {
  return {
    type: RECEIVE_LASTADJUSTMENTS,
    items: data,
    receivedAt: Date.now()
  };
}

export function fetchLastAdjustments() {
  return dispatch => {
    dispatch(requestLastAdjustments());
    return get(apiRoutes.lastadjustments.get(), function (response) {
      dispatch(receiveLastAdjustments(response.data));
    });
  };
}

function requestAnnotatedTexts() {
  return {
    type: REQUEST_ANNOTATEDTEXTS
  };
}

function receiveAnnotatedTexts(data) {
  return {
    type: RECEIVE_ANNOTATEDTEXTS,
    items: data,
    receivedAt: Date.now()
  };
}

export function fetchAnnotatedTexts(language) {
  return dispatch => {
    dispatch(requestAnnotatedTexts());
    return get(apiRoutes.annotatedTexts.get(language), function (response) {
      dispatch(receiveAnnotatedTexts(response.data));
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/modules/home/actions.js
 **/